import { filter, indexOf } from "lodash";
import { Facet } from "@linkfluence/models/facet";
import { Locale } from "@linkfluence/models/locale";
import { SharedFacetCtx } from "@radarly/models/shared-pages";
import { ClauseRepo } from "./ClauseRepo";

const getLabelsFromContext = (
  facet: Facet,
  context: SharedFacetCtx,
  values: any
) =>
  values.length
    ? filter(context[facet], (val) => indexOf(values, val.id) !== -1)
    : context[facet];

export class SharedClauseRepo implements ClauseRepo {
  facetContext: SharedFacetCtx;
  constructor(sharedPage: SharedFacetCtx) {
    this.facetContext = sharedPage;
  }

  public getBrandLogos(values: (number | string)[]) {
    return Promise.resolve(
      getLabelsFromContext(
        Facet.ImageRecognitionLogos,
        this.facetContext,
        values
      )
    );
  }

  public getCelebrities(values: (number | string)[]) {
    return Promise.resolve(
      getLabelsFromContext(
        Facet.ImageRecognitionPersonIdentifications,
        this.facetContext,
        values
      )
    );
  }

  public getOccupations(values: (number | string)[], locale: Locale) {
    return Promise.resolve(
      getLabelsFromContext(Facet.Occupations, this.facetContext, values)
    );
  }

  public getTowns(values: number[], projectID: number, locale: Locale) {
    return Promise.resolve(
      getLabelsFromContext(Facet.Towns, this.facetContext, values)
    );
  }
}
